export class NoFileChosenException extends Error {
  constructor(message: string) {
    super(message);
  }
}
